$ = require 'jquery'
Auth = require 'db/auth'
GoldBannerComponent = require 'views/member/gold-banner-component'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
View = require 'view'
_ = require 'underscore'
recup = require 'recup'
templates = require 'views/internal/templates'
localizeCount = require 'lib/localize-count'

{
  GOLD_RECOMMENDATION
  GOLD_UPGRADE
} = require 'data/gold-banners'

module.exports = class GoldView extends View
  initialize: ->
    @listenTo Auth.me(),
      'change:oneTimeMessagesDismissed': @frameDebounce @render

  getReactRoot: ->
    React.createElement ReactRootComponent, {},
      @getGoldBanner()

  renderReactSection: ->
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])

    @

  render: ->
    @$reactRoot ?= $('<div></div>')
    @$el.append(@$reactRoot)
    @renderReactSection()

    @

  getGoldBanner: ->
    {
      banner
      idNuxBannersToDismiss
    } = @options

    {
      invitedMemberNames
      numCreditMonths
      type
    } = banner

    idBannersToDismiss = (idNuxBannersToDismiss or []).concat([type])

    onDismissBanner = =>
      idBannersToDismiss.forEach (idBannerToDismiss) =>
        @model.dismiss(idBannerToDismiss)

    recup.render =>
      if !Auth.isMe(@model)
        return recup.div()

      if type == GOLD_UPGRADE and !@model.isDismissed(GOLD_UPGRADE)
        return recup.div =>
          recup.createElement GoldBannerComponent, {
            hasGold: true
            onDismissBanner
          }

      if type == GOLD_RECOMMENDATION and !@model.isDismissed(GOLD_RECOMMENDATION)
        return recup.div =>
          recup.createElement GoldBannerComponent, {
            hasGold: false
            invitedMemberNames
            onDismissBanner
            localizedMonthsOfCreditMessage: localizeCount('months of trello gold on us', numCreditMonths)
          }

      recup.div()

  remove: ->
    ReactDOM.unmountComponentAtNode(@$reactRoot[0])
    super



// WEBPACK FOOTER //
// ./app/scripts/views/member/gold-banner-view.coffee